import type { ThemeType } from '@shared/common-types.js'

export function getChartTheme(theme: ThemeType) {
  const isDark = theme === 'dark'
  return {
    isDark,
    gridColor: isDark ? '#374151' : '#e5e7eb',
    textColor: isDark ? '#d1d5db' : '#374151',
    axisLineColor: isDark ? '#4b5563' : '#d1d5db',
    cursorColor: isDark ? '#6b7280' : '#9ca3af',
    tooltipContentStyle: {
      backgroundColor: isDark ? '#1e293b' : '#fff',
      border: `1px solid ${isDark ? '#374151' : '#e5e7eb'}`,
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    },
    tooltipLabelStyle: {
      color: isDark ? '#f3f4f6' : '#111827',
      fontWeight: 600 as const,
    },
    tooltipItemStyle: {
      color: isDark ? '#d1d5db' : '#374151',
    },
    axisTickProps: {
      fontSize: 12,
      fill: isDark ? '#d1d5db' : '#374151',
    },
    axisLineProps: {
      stroke: isDark ? '#4b5563' : '#d1d5db',
    },
    tickLineProps: {
      stroke: isDark ? '#4b5563' : '#d1d5db',
    },
    legendStyle: {
      color: isDark ? '#d1d5db' : '#374151',
    },
  }
}
